module.exports = __webpack_public_path__ + "static/media/IndiaImg.d37656e2.svg";